import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
// @mui
import { Stack } from '@mui/system';
// sections
// reducers
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
//components
import BasicTable from 'components/BasicTable';
import { columnType } from 'components/BasicTable/types';
//constants
import {
	PaymentTableColumn,
	BeneficiaryDefaultSort,
	BeneficiaryId,
	Payment,
	BeneficiaryProfileDefaultSort,
} from 'constants/beneficiary.constants';
import { pagesEnum } from 'constants/ui.constants';
import { getNewBeneficiary } from 'state/reducers/beneficiary.reducers';
import { getCurrenciesObj, getCurrencyById } from 'state/reducers/global.reducers';

export default function PaymentsTable(props: { data: Payment[]; currencyId: number }) {
	const t = useAppSelector(selectTranslations);
	const currency = useAppSelector(getCurrencyById(props.currencyId));
	const prefixFields = `page.beneficiary.profile.payment_history.`;
	const beneficiariesColumns = () => {
		let columns: columnType[] = [];
		_.keys(PaymentTableColumn).forEach((element) => {
			let props: columnType = {
				fieldId: BeneficiaryId,
				name: element,
				title: t(prefixFields + 'table.column.' + _.snakeCase(element) + '.text'),
				type: PaymentTableColumn[element],
			};
			if (element === 'amount') {
				props.customValueHandle = (value) => {
					return (
						<>
							{currency?.symbol}
							{value}
						</>
					);
				};
			}
			if (element === 'status') {
				props.customValueHandle = (value) => {
					return <>{t(prefixFields + 'status.' + _.snakeCase(value) + '.text')}</>;
				};
			}
			columns.push(props);
		});
		return columns;
	};

	return (
		<Stack spacing={5}>
			<BasicTable
				data={props.data}
				columns={beneficiariesColumns()}
				defaultSortBy={BeneficiaryProfileDefaultSort}
			/>
		</Stack>
	);
}
